import { render, staticRenderFns } from "./TableStockoutPreview.vue?vue&type=template&id=4ded295d&scoped=true&"
import script from "./TableStockoutPreview.vue?vue&type=script&lang=js&"
export * from "./TableStockoutPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ded295d",
  null
  
)

export default component.exports